import React from 'react'
import './Footer.css';

const Footer = () => {
  
    return (
        <div className='footer'>
            <div className='footer__name'>
                <h3 className='footer__name-heading'>UMAIMA BAJAMAN</h3>
                <p>Graphic Designer | EXPRESSING CREATIVITY IN PIXELS AND PRINT</p>
            </div>
            <div className='footer__contact'>
                <h3 className='footer__name-heading'>CONTACT</h3> 
                <p>Email: umaima.bajaman@gmail.com <br />
                LinkedIn: www.linkedin.com/in/umaimab</p>
            </div>
        </div>
    )
  }


export default Footer